export const isShowEditSavedSearchBanner = (
    userAlertId: string | null,
    previousSavedSearchUri: string | null,
    currentSaveSearchUri?: string | null
) =>
    userAlertId &&
    previousSavedSearchUri &&
    previousSavedSearchUri !== currentSaveSearchUri;
